module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-pickwick-04.17f81b4b.jpg";